// removed by extract-text-webpack-plugin
module.exports = {"app":"FullscreenApp__app-1OGTn"};